<template>
  <div id="printOp" class="print-only">
      <CompanyInfo />
      <CompanyWatermark />
               <div class="content-wrapper">

    <div class="content-area">
  <div class="left-column">
    <p><span class="label">Reg No</span><span class="colon">:</span><span class="value">{{ patientId }}</span></p>
    <p><span class="label">Patient Name</span><span class="colon">:</span><span class="value">{{ patientDetails.name }}</span></p>
    <p><span class="label">Age</span><span class="colon">:</span><span class="value">{{ patientDetails.age }}</span></p>
    <p><span class="label">Sex</span><span class="colon">:</span><span class="value">{{ patientDetails.gender }}</span></p>
  </div>

  <div class="right-column">
    <p>
  <span class="label">Doctor Name</span>
  <span class="colon">:</span>
  <span class="value">
    {{ opPrintData.doctorName }}
    <span v-if="opPrintData.doctorDegree">
      , {{ opPrintData.doctorDegree }}
    </span>
  </span>
</p>
    <p><span class="label">Token No</span><span class="colon">:</span><span class="value">{{ opPrintData.tokenNo }}</span></p>
    <p><span class="label">Appointment Date & Time</span><span class="colon">:</span><span class="value">{{ formattedAppointmentDate }} - {{ formattedAppointmentTime }}</span></p>
  </div>
</div>
               </div>
   <CompanyFooter />
  </div>
</template>


<script>
import CompanyInfo from "@/components/CompanyInfo.vue";
import CompanyWatermark from "@/components/CompanyWatermark.vue";
import CompanyFooter from '../components/CompanyFooter.vue';
export default {
   components: {
    CompanyInfo,
    CompanyFooter,
    CompanyWatermark
  },
  props: {
    opPrintData: {
      type: Object,
      required: true
    },
    patientDetails: {
      type: Object,
      required: true
    },
    patientId: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    formattedAppointmentDate() {
      if (!this.opPrintData.appointmentDate) return "";

      const [year, month, day] = this.opPrintData.appointmentDate.split("-");
      return `${day}/${month}/${year}`;  // convert to DD/MM/YYYY
    },

    formattedAppointmentTime() {
      if (!this.opPrintData.appointmentTime) return "";

      let [hours, minutes] = this.opPrintData.appointmentTime.split(":");
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);

      // Convert to AM/PM
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }
},
/*methods: {
    getBase64(path) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = path;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = reject;
      });
    },

async loadImages() {
  const companyId = this.$session.get("companyId");

  const tryImage = async (path) => {
    try {
      return await this.getBase64(path);
    } catch (e) {
      return null;
    }
  };

  const headerBase64 =
    (await tryImage(`/images/company${companyId}/header.png`)) ||
    (await tryImage(`/images/company${companyId}/header.jpg`)) ||
    (await tryImage(`/images/company${companyId}/header.jpeg`));

  const footerBase64 =
    (await tryImage(`/images/company${companyId}/footer.png`)) ||
    (await tryImage(`/images/company${companyId}/footer.jpg`)) ||
    (await tryImage(`/images/company${companyId}/footer.jpeg`));

  const watermarkBase64 =
    (await tryImage(`/images/company${companyId}/watermark.png`)) ||
    (await tryImage(`/images/company${companyId}/watermark.jpg`)) ||
    (await tryImage(`/images/company${companyId}/watermark.jpeg`));

  return { headerBase64, footerBase64, watermarkBase64 };
},


    async buildDocDefinition() {
      const { headerBase64, footerBase64, watermarkBase64 } = await this.loadImages();

      return {
        pageSize: "A4",
        pageMargins: [30, 120, 20, 100],

        header: headerBase64
          ? { image: headerBase64, width:600, alignment: "center" }
          : null,

        footer: footerBase64
          ? { image: footerBase64, width: 600, alignment: "center" }
          : null,

        background: watermarkBase64
          ? (currentPage, pageSize) => ({
              image: watermarkBase64,
              width: 300,
              opacity: 0.08,
              absolutePosition: {
                x: (pageSize.width - 300) / 2,
                y: (pageSize.height - 300) / 2
              }
            })
          : null,

        content: [
          {
            columns: [
              [
                { text: [{ text: "Reg No: ", bold: true }, { text: this.patientId }] },
                { text: [{ text: "Patient Name: ", bold: true }, { text: this.patientDetails.name }] },
                { text: [{ text: "Age: ", bold: true }, { text: this.patientDetails.age }] },
                { text: [{ text: "Sex: ", bold: true }, { text: this.patientDetails.gender }] }
              ],
              [
                { text: [{ text: "Doctor Name: ", bold: true }, { text: this.opPrintData.doctorName }] },
                { text: [{ text: "Token No: ", bold: true }, { text: this.opPrintData.tokenNo }] },
                { text: [{ text: "Appointment Date & Time: ", bold: true }, { text: `${this.formattedAppointmentDate} - ${this.formattedAppointmentTime}` }] }
             
             
             ]
            ],
          
          
          },

          { canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ], margin: [0, 10, 0, 10] }
          
        ]
      };
    }
}*/

}
</script>


